import { customerEnquiryItinerary } from "@travellocal/utils/webRoutes";
import { LocationDescriptorObject } from "history";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { replace } from "react-router-redux";
import _ from "underscore";
import { RoutesInvoker } from "../../../routesInvoker";

interface StateProps {
  enquiryState: IState<IEnquiry>;
  routing: RouterReducer;
}

interface DispatchProps {
  redirectToItinerary: (enquiryId: number, itineraryId: number) => void;
}

type Props = DispatchProps & StateProps;

const stateToProps = (state: IWebStoreState): StateProps => {
  return {
    enquiryState: state.customerEnquiry,
    routing: state.routing,
  };
};

const dispatchToProps = (dispatch): DispatchProps => {
  return {
    redirectToItinerary: (enquiryId: number, quoteId: number) =>
      dispatch(replace(customerEnquiryItinerary(enquiryId, quoteId))),
  };
};

class ItineraryRedirectComponent extends React.Component<Props> {
  public constructor(props) {
    super(props);
    this.state = {};
  }

  private ensureHasItinerary = (props: Props) => {
    const enquiryState = props.enquiryState;
    if (enquiryState.status !== "OK" || !enquiryState.data || !enquiryState.data.currentQuoteId) {
      return;
    }

      // customer/:enquiryId/itinerary/ should redirect to the latest itinerary available.
    const hasItinerary = enquiryState.data.currentQuoteId != null;
    const loc = props.routing.locationBeforeTransitions as LocationDescriptorObject;
    const isItineraryRoute = loc.pathname.includes("itinerary");

    if (hasItinerary && isItineraryRoute) {
      props.redirectToItinerary(enquiryState.data.id, enquiryState.data.currentQuoteId);
    }
    return;

    // TODO ensure itinerary in state matches the one from the route
    // Not possible because itinerary in state doesn't have its quote id anywhere
    // else {
    //   let itineraryState = props.customerEnquiryItinerary;
    //   if (itineraryState.status != "OK" || !itineraryState.data) {
    //     return;
    //   }

    //   let itinIdFromRoute = parseInt(routeQuoteId);
    //   if (itineraryState.data.id != itinIdFromRoute) {
    //     let itinId = !isNaN(itinIdFromRoute) ? itinIdFromRoute : null;
    //     this.props.redirectToItinerary(enquiryState.data.id, itinId);
    //   }
    // }
  }

  public componentWillMount() {
    this.ensureHasItinerary(this.props);
  }

  public render() {
    const enquiry = this.props.enquiryState.data;
    const hasItinerary = enquiry.currentQuoteId != null && enquiry.currentItinerarySummary != null;
    return (
      <>
        {!hasItinerary &&
          <div className="customer-enquiry-itinerary">
            <section className="width-wrapper itinerary-pending-message">
              <p>There's no itinerary to show right now.</p>
              <p><Link to={RoutesInvoker.customerIndex}>Back to Home</Link></p>
            </section>
          </div>
        }
      </>
    );
  }
}

export const ItineraryRedirect = connect(stateToProps, dispatchToProps)(ItineraryRedirectComponent);
